"use strict";
module.exports = require('./en');
